import { styled } from "@mui/material/styles";
import Button from '@mui/material/Button';


export const DialogButton = styled((props: any) => <Button {...props} />)(
  ({ theme }) => ({
    border: 0,
    fontWeight: 700,
    fontFamily: "OpenSans,Arial",
    lineHeight: "1.8rem",
    padding: "1.0rem 3.0rem",
    marginRight: "1.0rem",
    textTransform: "none",
    backgroundColor: theme.palette.fuchsiaAccessible.main,
    color: theme.palette.white.main,
    borderRadius: "27.5px",
    fontSize: "1em",
    "&:disabled": {
      border: `0.1rem solid ${theme.palette.disabled.main}`,
      color: theme.palette.white.main,
      backgroundColor: theme.palette.disabled.main
    },
    "&:hover": {
      color: theme.palette.white.main,
      backgroundColor: theme.palette.fuchsiaAccessible.main
    }
    
  })
);
